module.exports = __webpack_public_path__ + "assets/273dbf6de79eb180a8774cb57ba1dd2e.mp3";